export default "__VITE_ASSET__78030c6a__"